// @ts-nocheck
import { menuDrawerGetProps } from "@store/Themes/common/props/menu";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

const props = menuDrawerGetProps({
    backgroundColor: "common.background",
    color: "text.linkAlt",
    hoverColor: "text.linkAltHover",
    borderColor: "common.border",
});

const drawer: Styleguide["drawer"] = {
    defaultProps: {
        headlineTypographyProps: {
            forwardAs: "span",
            variant: null as any,
            // "css" cannot be used here, use "cssOverrides/headlineTypography" instead
        },
        closeButtonProps: props.closeButton,
        closeButtonIconProps: props.closeButtonIcon,
        cssOverrides: {
            drawerBody: props.wrapperCss,
            drawerTitle: props.headerCss,
            headlineTypography: css`
                flex: 1 1 auto;
                text-transform: uppercase;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;

                ${({ theme }) => css`
                    padding: ${theme.design.menu.panel.rowPadding};
                    font-weight: ${theme.design.typography.weight.bold};
                    line-height: ${theme.design.typography.lineHeight.small};
                    font-size: ${theme.design.typography.size.smaller};
                `}

                padding-top: 0;
                padding-right: 0;
                padding-bottom: 0;
            `,
        },
    },
};

export default drawer;
